module.exports = __webpack_public_path__ + "img/pwa-install.450ba239.png";